import { useState } from 'react'
import { Link, useNavigate } from 'react-router-dom'
import { FINISH_ROUTE, STEPS, getOnboardingContext, skipOnboardingStep, stepIndex } from '../../utils/onboarding'

// A slim strip at the top of a step's page while a company is on that step
// of Getting started: which step this is, skip it for now, or see all steps.
// Shows nothing otherwise, so a page can always include it.
export default function OnboardingStepBar({ step }) {
  const nav = useNavigate()
  const [ctx] = useState(() => getOnboardingContext())
  const i = stepIndex(step)
  if (!ctx?.inOnboarding || ctx.activeStep !== step || i === -1) return null
  const skip = () => {
    const r = skipOnboardingStep(step)
    nav(r.nextRoute || FINISH_ROUTE)
  }
  return (
    <div className="gs-bar" role="status">
      <span><strong>Getting started</strong> · Step {i + 1} of {STEPS.length}: {STEPS[i].title}</span>
      <span className="gs-bar-actions">
        <button type="button" className="ci-btn ci-btn-ghost ci-btn-sm" onClick={skip}>Skip for now</button>
        <Link className="ci-btn ci-btn-ghost ci-btn-sm" to="/onboarding">All steps</Link>
      </span>
    </div>
  )
}
